import { differenceInMilliseconds, parse } from 'date-fns'
import { Component } from 'react'
import { TFunction, withTranslation } from 'react-i18next'

import TimePicker from '@/utilities/client-components/components/TimePicker'

import withSpacing from './WithSpacing'

interface InputTimeProps {
  document?: object
  id?: string
  isRequired?: boolean
  label?: string
  max?: string
  min?: string
  placeholder?: string
  registerInputCallback(...args: unknown[]): unknown
  t: TFunction
}

class InputTime extends Component<InputTimeProps> {
  static displayName = 'InputDate'

  constructor(props: any) {
    super(props)

    this.state = {
      value: null,
      error: ''
    }

    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount() {
    const { registerInputCallback } = this.props
    registerInputCallback(this)
  }

  value() {
    // @ts-expect-error
    return this.state.value ? parse(this.state.value, 'HH:mm', new Date()) : undefined
  }

  id() {
    return this.props.id
  }

  handleChange(value: any) {
    this.setState({ value, error: '' })
  }

  //TODO min / max validation
  validate() {
    const { isRequired, min, max, t } = this.props
    // @ts-expect-error
    const { value: valAsString } = this.state

    if (!valAsString && isRequired) {
      // See if the value is null, if so and we are required we are simply invalid
      this.setState({
        error: t('client:required')
      })
      return false
    } else if (valAsString) {
      const value = parse(valAsString, 'HH:mm', new Date())
      // If the date format is invalid, we will simply have Invalid Date but still `instanceof Date`
      if (Number.isNaN(value) || String(value) === 'Invalid Date') {
        this.setState({
          error: t('client:InputTime.invalidFormat')
        })
        return false
      }

      // Now check the max/min values
      let isAfterMin = true
      if (min) {
        isAfterMin = differenceInMilliseconds(new Date(min), value) < 0
      }
      let isBeforeMax = true
      if (max) {
        isBeforeMax = differenceInMilliseconds(new Date(max), value) > 0
      }

      if (!isAfterMin) {
        this.setState({
          error: t('client:InputTime.invalidMin')
        })
      } else if (!isBeforeMax) {
        this.setState({
          error: t('client:InputTime.invalidMax')
        })
      }

      return isAfterMin && isBeforeMax
    }
  }

  render() {
    // @ts-expect-error
    const { value, error } = this.state
    const { isRequired, label, min, max } = this.props

    return (
      <TimePicker
        label={label}
        // @ts-expect-error
        dateFormat={false}
        isRequired={isRequired}
        value={value}
        onChange={this.handleChange}
        error={error}
        minTime={min}
        maxTime={max}
      />
    )
  }
}

export default withSpacing(withTranslation('client')(InputTime))
export { InputTime }
